import React, { useRef } from 'react';
import { Link } from 'gatsby';

import ColorHelper from '../_helpers/_color_helper';

import styles from '../../styles/_components/_buttons/_button_square.module.scss';

export const Button_Square_types = {
    LIGHT: 'oButtonSquareLight',
    REGULAR: ''
}

export const ButtonSquare = ({ _text, _slug, _to = '', _bg_color = '', _textColor = '', _className, _button_type, _activeClassName, _onClick, _is_selected = false }) => {

    const shadow_color = `${ColorHelper.hexToRGB(_bg_color, 0.5)}`
    const type = styles[_button_type || Button_Square_types.REGULAR];
    const class_light = _button_type === Button_Square_types.LIGHT ? 'o-button-square--light' : ' ';
    const class_selected = _is_selected ? 'o-button-square--selected' : '';
    const buttonShadow = useRef(null);

    const isExternalLink = (url) => {
        return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//');
    }

    const isExternal = isExternalLink(_to);

    // Estilos y clases comunes
    const commonStyle = _bg_color !== '' ? { backgroundColor: `${_bg_color}` } : {};
    const commonClasses = `${_className} ${styles.oButtonSquare} ${type} ${class_light} ${class_selected} ${_textColor}`;
    const textClasses = `${styles.oButtonSquare_type_item} ${_textColor}`;

    // Contenido común
    const buttonContent = <p className={textClasses}>{_text}</p>;

    // Función para renderizar según el tipo
    const renderButton = () => {
        // Si no hay URL de destino
        if (_to === '') {
            if (_onClick) {
                return (
                    <div onClick={_onClick} ref={buttonShadow} style={commonStyle} className={commonClasses}>
                        {buttonContent}
                    </div>
                );
            }
            return (
                <div ref={buttonShadow} style={commonStyle} className={commonClasses}>
                    {buttonContent}
                </div>
            );
        }

        // Si es un link externo
        if (isExternal) {
            return (
                <a href={_to} target="_blank" rel="noopener noreferrer" ref={buttonShadow} 
                   style={commonStyle} className={commonClasses}>
                    {buttonContent}
                </a>
            );
        }

        // Si es un link interno (Gatsby Link)
        return (
            <Link to={_to} ref={buttonShadow} style={commonStyle} 
                  className={commonClasses} activeClassName={_activeClassName}>
                {buttonContent}
            </Link>
        );
    };

    return renderButton();
}
